import * as boardApi from '@/api/boardApi'
import { useUserStore } from '@/stores/userStore'

export default {
    namespaced: true,
    state() {
        return {
            listStatus: [],
        }
    },
    getters: {
        getList(state) {
            return state.listStatus
        },
    },
    mutations: {
        setList(state, listData) {
            state.listStatus = JSON.parse(listData)
        },
    },
    actions: {
        async list({ commit }, projectId) {
            const token = useUserStore().token || JSON.parse(localStorage.getItem('user'))?.token
            if (!token) return

            const dataResp = await boardApi.listSt(token, projectId)

            if (dataResp) {
                commit('setList', JSON.stringify(dataResp))
            }
        },
        async updatSt({ commit }, data) {
            const token = useUserStore().token || JSON.parse(localStorage.getItem('user'))?.token
            if (!token) return

            const dataResp = await boardApi.updateStatus(token, data)
        },
        async delSt({ commit }, id) {
            const token = useUserStore().token || JSON.parse(localStorage.getItem('user'))?.token
            if (!token) return

            const dataResp = await boardApi.delStatus(token, id)
        },
        async updatTsk({ commit }, data) {
            const token = useUserStore().token || JSON.parse(localStorage.getItem('user'))?.token
            if (!token) return false

            const dataResp = await boardApi.updateTask(token, data)
            return dataResp
        },
        async updatSubTsk({ commit }, data) {
            const token = useUserStore().token || JSON.parse(localStorage.getItem('user'))?.token
            if (!token) return false
            
            const dataResp = await boardApi.updateSubTask(token, data)
            return dataResp
        },        
        async updatTskDate({ commit }, data) {
            const token = useUserStore().token || JSON.parse(localStorage.getItem('user'))?.token
            if (!token) return

            const dataResp = await boardApi.updateTaskDate(token, data)
        },   
        async updatSubTskDate({ commit }, data) {
            const token = useUserStore().token || JSON.parse(localStorage.getItem('user'))?.token
            if (!token) return

            const dataResp = await boardApi.updateSubTaskDate(token, data)
        },              
        async clearTskDate({ commit }, data) {
            const token = useUserStore().token || JSON.parse(localStorage.getItem('user'))?.token
            if (!token) return

            const dataResp = await boardApi.clearTaskDate(token, data)
        },
        async clearSubTskDate({ commit }, data) {
            const token = useUserStore().token || JSON.parse(localStorage.getItem('user'))?.token
            if (!token) return

            const dataResp = await boardApi.clearSubTaskDate(token, data)
        },                    
        async delTsk({ commit }, id) {
            const token = useUserStore().token || JSON.parse(localStorage.getItem('user'))?.token
            if (!token) return

            const dataResp = await boardApi.delTask(token, id)
        },
        async delSubTsk({ commit }, id) {
            const token = useUserStore().token || JSON.parse(localStorage.getItem('user'))?.token
            if (!token) return

            const dataResp = await boardApi.delSubTask(token, id)
        },        
        async archTsk({ commit }, id) {
            const token = useUserStore().token || JSON.parse(localStorage.getItem('user'))?.token
            if (!token) return

            const dataResp = await boardApi.archTask(token, id)
        },   
        async archTskList({ commit }, id) {
            const token = useUserStore().token || JSON.parse(localStorage.getItem('user'))?.token
            if (!token) return

            const dataResp = await boardApi.archTaskList(token, id)
            return dataResp
        },              
        async listPerformers({commit}, data) {
            const token = useUserStore().token || JSON.parse(localStorage.getItem('user'))?.token
            if (!token) return

            const dataResp = await boardApi.listPerformers(token, data)
            return dataResp
        },        
        async assignPerformer({commit}, data) {
            const token = useUserStore().token || JSON.parse(localStorage.getItem('user'))?.token
            if (!token) return

            const dataResp = await boardApi.assignPerformer(token, data)
        },
        async detachPerformer({commit}, data) {
            const token = useUserStore().token || JSON.parse(localStorage.getItem('user'))?.token
            if (!token) return

            const dataResp = await boardApi.detachPerformer(token, data)
        }, 
        async listControllers({commit}, data) {
            const token = useUserStore().token || JSON.parse(localStorage.getItem('user'))?.token
            if (!token) return

            const dataResp = await boardApi.listControllers(token, data)
            return dataResp
        },        
        async assignController({commit}, data) {
            const token = useUserStore().token || JSON.parse(localStorage.getItem('user'))?.token
            if (!token) return

            const dataResp = await boardApi.assignController(token, data)
        },
        async detachController({commit}, data) {
            const token = useUserStore().token || JSON.parse(localStorage.getItem('user'))?.token
            if (!token) return

            const dataResp = await boardApi.detachController(token, data)
        },         
        async uploadFiles({commit}, data) {
            const token = useUserStore().token || JSON.parse(localStorage.getItem('user'))?.token
            if (!token) return

            const dataResp = await boardApi.uploadFiles(token, data)
        },     
        async uploadSubFiles({commit}, data) {
            const token = useUserStore().token || JSON.parse(localStorage.getItem('user'))?.token
            if (!token) return

            const dataResp = await boardApi.uploadSubFiles(token, data)
        },         
        async deleteFile({commit}, id) {
            const token = useUserStore().token || JSON.parse(localStorage.getItem('user'))?.token
            if (!token) return

            const dataResp = await boardApi.deleteFile(token, id)
        },   
        async deleteSubFile({commit}, id) {
            const token = useUserStore().token || JSON.parse(localStorage.getItem('user'))?.token
            if (!token) return

            const dataResp = await boardApi.deleteSubFile(token, id)
        },
        async addTaskComment({commit}, data) {
            const token = useUserStore().token || JSON.parse(localStorage.getItem('user'))?.token
            if (!token) return

            const dataResp = await boardApi.addTaskComment(token, data)
            return dataResp
        }, 
        async deleteTaskComment({commit}, data) {
            const token = useUserStore().token || JSON.parse(localStorage.getItem('user'))?.token
            if (!token) return

            const dataResp = await boardApi.deleteTaskComment(token, data)
            return dataResp
        },          
        async searchTags({ commit }, data) {
            const token = useUserStore().token || JSON.parse(localStorage.getItem('user'))?.token
            if (!token) return

            const dataResp = await boardApi.searchTags(token, data)
            return dataResp
        },     
        async addTag({ commit }, data) {
            const token = useUserStore().token || JSON.parse(localStorage.getItem('user'))?.token
            if (!token) return

            const dataResp = await boardApi.addTag(token, data)
            return dataResp
        },    
        async removeTag({ commit }, data) {
            const token = useUserStore().token || JSON.parse(localStorage.getItem('user'))?.token
            if (!token) return

            const dataResp = await boardApi.removeTag(token, data)
            return dataResp
        },
        async uploadCover({commit}, data) {
            const token = useUserStore().token || JSON.parse(localStorage.getItem('user'))?.token
            if (!token) return

            const dataResp = await boardApi.uploadCover(token, data)
            return dataResp
        },       
        async removeCover({commit}, data) {
            const token = useUserStore().token || JSON.parse(localStorage.getItem('user'))?.token
            if (!token) return

            const dataResp = await boardApi.removeCover(token, data)
            return dataResp
        },   
        async completeTask({commit}, data) {
            const token = useUserStore().token || JSON.parse(localStorage.getItem('user'))?.token
            if (!token) return

            const dataResp = await boardApi.completeTask(token, data)
            return dataResp
        },   
        async completeSubTask({commit}, data) {
            const token = useUserStore().token || JSON.parse(localStorage.getItem('user'))?.token
            if (!token) return

            const dataResp = await boardApi.completeSubTask(token, data)
            return dataResp
        },                                                                        
        async sortAll({ commit }, data) {
            const token = useUserStore().token || JSON.parse(localStorage.getItem('user'))?.token
            if (!token) return

            const dataResp = await boardApi.sortAll(token, data)
        },
        async updateCheck({ commit }, data) {
            const token = useUserStore().token || JSON.parse(localStorage.getItem('user'))?.token
            if (!token) return

            const dataResp = await boardApi.updateCheck(token, data)    
            return dataResp
        },
        async deleteCheck({ commit }, data) {
            const token = useUserStore().token || JSON.parse(localStorage.getItem('user'))?.token
            if (!token) return

            const dataResp = await boardApi.deleteCheck(token, data)
            return dataResp
        },        
    }
}